export const FILE = {
	VIDEO: 'video',
	PDF: 'pdf',
	LINK: 'link',
	IMAGE: 'image',
	FILE: 'file',
};
